import React, { useEffect, useState } from 'react';
import {
  AppBar,
  Toolbar,
  Typography,
  Button,
  useTheme,
  useMediaQuery,
  Menu,
  MenuItem,
  Dialog,
  DialogTitle,
  DialogContent
} from '@mui/material';
import { Link } from 'react-router-dom';
import image3 from './chirantanlogore.jpg';
import PatientForm from '../Patient/patientForms/PatientForm';
import OldPatient from './OldPatient';
import ScheduleIcon from '@mui/icons-material/Schedule';

const buttonStyles = {
  color: '#FFFFFF',
  '&:hover': {
    color: '#e0dccc',
    backgroundColor: 'transparent'
  }
};

const NavBar = () => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down('md'));

  const [isScrolled, setIsScrolled] = useState(false);
  const [anchorEl, setAnchorEl] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedOption, setSelectedOption] = useState(null);

  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  const handleDialogOpen = (option) => {
    setSelectedOption(option);
    setOpenDialog(true);
    handleClose();
  };

  const handleDialogClose = () => {
    setOpenDialog(false);
  };

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      setIsScrolled(scrollTop > 0);
    };

    window.addEventListener('scroll', handleScroll);

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, []);

  return (
    <>
      <Dialog open={openDialog} onClose={handleDialogClose}>
        <DialogTitle>{selectedOption === 'NewPatient' ? 'New Patient' : 'Old Patient'}</DialogTitle>
        <DialogContent>
          {selectedOption === 'NewPatient' && <PatientForm handleCloseDialog={handleDialogClose} />}
          {selectedOption === 'OldPatient' && <OldPatient handleDialogClose={handleDialogClose} />}
        </DialogContent>
      </Dialog>

      <AppBar
        position="fixed"
        elevation={0}
        style={{
          backgroundColor: 'black',
          width: '100%',
          top: 0,
          zIndex: 2,
          opacity: isScrolled ? 0 : 1,
          transition: 'opacity 1.0s ease-in-out'
        }}
      >
        <Toolbar sx={{ justifyContent: 'space-between' }}>
          <img src={image3} alt="College Logo" style={{ height: '60px' }} />
          <Typography
            variant="h6"
            style={{
              color: 'white',
              textAlign: 'center',
              fontFamily: 'cursive'
            }}
          >
            "CHIRANTHAN DENTAL CARE"
          </Typography>
          <Toolbar style={{ justifyContent: 'flex-end' }}>
            <div style={{ flexGrow: 1, textAlign: 'right' }}>
              <Button color="inherit" sx={buttonStyles} component={Link} to="/">
                Home
              </Button>
              <Button color="inherit" sx={buttonStyles} component={Link} to="contact-us">
                Contact US
              </Button>
              {/* <img src='assets/comp/scheduleButton.png' /> */}
              <Button
                variant="contained"
                color="primary"
                sx={buttonStyles}
                onClick={handleClick}
                startIcon={<ScheduleIcon />}
              >
                Book an Appointment
              </Button>
              <Menu
                id="appointment-menu"
                anchorEl={anchorEl}
                keepMounted
                open={Boolean(anchorEl)}
                onClose={handleClose}
              >
                <MenuItem onClick={() => handleDialogOpen('NewPatient')}>
                  Want to Register?
                </MenuItem>
                <MenuItem onClick={() => handleDialogOpen('OldPatient')}>
                  Already Have an Appointment?
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </Toolbar>
      </AppBar>
    </>
  );
};

export default NavBar;
